import { useState, useEffect } from 'react';
import { AppData } from '../types';
import useClientApi from './useClientApi';
import useIssuesApi from './useIssuesApi';
import useMessagesApi from './useMessagesApi';

const useAppData = (clientId: string): { appData?: AppData; loading: boolean } => {
  const { client, loading: loadingClient, error: errorClient } = useClientApi(clientId);
  const { messages, loading: loadingMessages } = useMessagesApi(
    clientId,
    client?.customerDetails?.firstName || '',
    client?.benchContacts?.bookkeeper?.primary?.id || '',
  );
  const { issues, loading: loadingIssues } = useIssuesApi(clientId, messages?.recentMessages);
  const [appData, setAppData] = useState<AppData>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (loadingClient || loadingMessages || loadingIssues) return;
    setLoading(false);
  }, [loadingClient, loadingMessages, loadingIssues]);

  useEffect(() => {
    if (!errorClient) return;
    setLoading(false);
  }, [errorClient]);

  useEffect(() => {
    if (loading || !client || !messages || !issues) return;
    const data: AppData = {
      clientId,
      ...client,
      recentMessages: messages?.recentMessages || [],
      ...issues,
    };
    setAppData(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  return { appData, loading };
};

export default useAppData;
